(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cio-banco"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.documentElement.classList.add('js');
    var script = document.currentScript;
    var root = script && script.closest ? script.closest('.shopify-section') : null;
    var scope = root || document;
    var items = scope.querySelectorAll('.cio-rv:not(.in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );
    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cio-fiducia"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.documentElement.classList.add('js');
    var script = document.currentScript;
    var root = script && script.closest ? script.closest('.shopify-section') : null;
    var scope = root || document;
    var items = scope.querySelectorAll('.cio-rv:not(.in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );
    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cio-finale"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.documentElement.classList.add('js');
    var script = document.currentScript;
    var root = script && script.closest ? script.closest('.shopify-section') : null;
    var scope = root || document;
    var items = scope.querySelectorAll('.cio-rv:not(.in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );
    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cio-firma"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.documentElement.classList.add('js');
    var script = document.currentScript;
    var root = script && script.closest ? script.closest('.shopify-section') : null;
    var scope = root || document;
    var items = scope.querySelectorAll('.cio-rv:not(.in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );
    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cio-pagina-chi-siamo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.documentElement.classList.add('js');
    var items = document.querySelectorAll('.cio-rv:not(.in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );
    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cio-pagina-contatti"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.documentElement.classList.add('js');
    var items = document.querySelectorAll('.cio-rv:not(.in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );
    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cio-passi"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.documentElement.classList.add('js');
    var script = document.currentScript;
    var root = script && script.closest ? script.closest('.shopify-section') : null;
    var scope = root || document;
    var items = scope.querySelectorAll('.cio-rv:not(.in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );
    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cio-recensioni-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.documentElement.classList.add('js');
    var script = document.currentScript;
    var root = script && script.closest ? script.closest('.shopify-section') : null;
    var scope = root || document;
    var items = scope.querySelectorAll('.cio-rv:not(.in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );
    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cio-storia"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.documentElement.classList.add('js');
    var script = document.currentScript;
    var root = script && script.closest ? script.closest('.shopify-section') : null;
    var scope = root || document;
    var items = scope.querySelectorAll('.cio-rv:not(.in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );
    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
